// extracted by mini-css-extract-plugin
export var modal = "_tr-0";
export var table = "_tr-1";